export const formatPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(
    /(\d{2})(\d{2})(\d{3})(\d{2})(\d{2})/,
    '$1 (0)$2 $3 $4 $5'
  );
};
